import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, Users, FileText, ListTodo, Menu } from "lucide-react";

const tabs = [
  { path: "/", label: "Start", icon: LayoutDashboard, match: (p) => p === "/" },
  { path: "/customers", label: "Kunden", icon: Users, match: (p) => p.startsWith("/customers") },
  { path: "/service-reports", label: "Berichte", icon: FileText, match: (p) => p.startsWith("/service-reports") },
  { path: "/tasks", label: "Aufgaben", icon: ListTodo, match: (p) => ["/tasks", "/mein-tag", "/meine-woche", "/planung"].some((x) => p.startsWith(x)) },
];

const TabButton = ({ active, label, Icon, testId }) => (
  <>
    <span
      className={`absolute top-0 h-[3px] w-9 rounded-full transition-all duration-200 ${
        active ? "bg-primary opacity-100" : "opacity-0"
      }`}
    />
    <span
      className={`flex items-center justify-center w-12 h-7 rounded-full transition-colors duration-200 ${
        active ? "bg-primary/15 text-primary" : "text-muted-foreground"
      }`}
    >
      <Icon className="w-[22px] h-[22px]" strokeWidth={active ? 2.3 : 1.8} />
    </span>
    <span
      className={`text-[10.5px] leading-none truncate max-w-full px-0.5 transition-colors duration-200 ${
        active ? "text-primary font-semibold" : "text-muted-foreground font-medium"
      }`}
    >
      {label}
    </span>
  </>
);

export const MobileBottomNav = ({ onMenuClick, unreadCount = 0 }) => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-card/95 backdrop-blur-lg border-t border-border shadow-[0_-2px_12px_rgba(0,0,0,0.06)] pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-stretch justify-around h-[68px]">
        {tabs.map((tab) => {
          const active = tab.match(path);
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className="relative flex flex-col items-center justify-center gap-1 flex-1 min-w-0 active:scale-95 transition-transform"
              data-testid={`mobile-bottom-nav-${tab.path.replace("/", "") || "dashboard"}`}
            >
              <TabButton active={active} label={tab.label} Icon={tab.icon} />
            </Link>
          );
        })}
        <button
          type="button"
          onClick={onMenuClick}
          className="relative flex flex-col items-center justify-center gap-1 flex-1 min-w-0 active:scale-95 transition-transform"
          data-testid="mobile-bottom-nav-menu"
        >
          <TabButton active={false} label="Menü" Icon={Menu} />
          {unreadCount > 0 && (
            <span
              className="absolute top-1 right-[calc(50%-20px)] min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] font-bold rounded-full bg-red-500 text-white ring-2 ring-card"
              data-testid="mobile-bottom-nav-chat-badge"
            >
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </button>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
